<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Replace Component</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Component</span>
            <span class="label">{{componentName}}</span>
        </div>
        <div class="input-container">
            <span class="label">Cost</span>
            <span class="input-icon">$</span>
            <input type="number" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" />
        </div>
        <div class="input-container">
            <span class="label">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()" matTooltip="{{ttDate}}">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" 
                   [min]="minDate" [max]="maxDate" placeholder="Choose a date" 
                   [(ngModel)]="eventDate" (ngModelChange)="dateChanged()" 
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="margin-bottom-16">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" 
                  placeholder="Enter a comment about this repair. " 
                  matTooltip="{{ttComment}}"></textarea>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>